<template>
  <div class="screen-wrapper" :style="screenWrapperStyle">
    <div class="screen" :style="screenStyle">
      <PubDetailHeaderSubsection />
      <PubDetailContentSubsection ref="content" @ready="updateFooterTop" />
      <Group3Subsection :top="footerTop" />
    </div>
  </div>
</template>

<script>
import Group3Subsection from "../Screen/sections/Group3Subsection.vue";
import PubDetailHeaderSubsection from "./sections/PubDetailHeaderSubsection.vue";
import PubDetailContentSubsection from "./sections/PubDetailContentSubsection.vue";

export default {
  name: "PubDetailScreen",
  components: { Group3Subsection, PubDetailHeaderSubsection, PubDetailContentSubsection },
  data() {
    return {
      baseWidth: 1920,
      baseHeight: 924,
      viewportWidth: 0,
      viewportHeight: 0,
      footerTop: 2100,
    };
  },
  computed: {
    scale() {
      const w = this.viewportWidth || this.baseWidth;
      const clamped = Math.min(w, this.baseWidth);
      return clamped / this.baseWidth;
    },
    screenStyle() {
      const minBase = Math.max(this.baseHeight, this.footerTop + 233);
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: "top center",
        width: this.baseWidth + "px",
        position: "relative",
        minHeight: minBase + "px",
      };
    },
    screenWrapperStyle() {
      const minBase = Math.max(this.baseHeight, this.footerTop + 233);
      return {
        width: "100%",
        height: minBase * this.scale + "px",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      };
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    this.$nextTick(this.updateFooterTop);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      this.$nextTick(this.updateFooterTop);
    },
    updateFooterTop() {
      const el = this.$refs.content && this.$refs.content.$el ? this.$refs.content.$el : null;
      const h = el ? el.offsetHeight : this.baseHeight - 300;
      const contentTop = el ? el.offsetTop : 0;
      const viewBase = (this.viewportHeight || this.baseHeight) / (this.scale || 1);
      const bottomSpace = 80;
      const footerHeight = 233;
      const desired = Math.max(contentTop + h + bottomSpace, viewBase - footerHeight);
      this.footerTop = Math.round(desired);
    },
  },
  watch: {
    "$route.fullPath"() {
     this.$nextTick(() => this.updateFooterTop());
    },
  },
};
</script>

<style scoped>
.screen { min-width: 1920px; position: relative; width: 100%; }
.screen-wrapper { width: 100%; position: relative; overflow: visible; min-height: 100vh; }
</style>
